export default {
  legal: {
    identity: {
      title: '事業タイプ',
      legal: '法人',
      personal: '個人事業主',
    },
    basic: {
      title: '法人基本情報（＊必須項目）',
      title_p:'個人事業主基本情報（＊必須項目）',
      number: '法人番号',
      numberTip: '半角数字13桁',
      checkTag: '適格請求書発行事業者',
      reminderText: '適格請求書発行事業者であれば、チェックしてください',


      label1: '法人名',
      tip1: '例：株式会社〇〇',
      label2: '全角カタカナ',
      tip2: '例：カブシキガイシャ○○',
      label3: '英語表記',
      tip3: '例：〇〇 Co., Ltd.',
      label4: '法人設立年月日',
      tip4: '2010/1/1',
      label5: '法人種別',
      tip5: '',
      label6: '屋号や法人略称',
      label6tip: '決済画面に表示する',
      label6_p: '個人事業主略称（屋号）',
      tip6: '例：環球支付',
      label7: '全角カタカナ',
      tip7: '例：カンキュウシフ',
      label8: '英語名称',
      tip8: '例：GLOBEPAY',
      label9: '会社URL',
      tip9: '例：https://www.globepay.co.jp',
      label10: '(予測)年商（単位：万円）',
      tip10: '前期会社全体の年商の入力をお願いします。設立1年未満の場合は、予想年商を入力します。',
      label11: '資本金(単位：万円)',
      tip11: '',
      label12: '従業員数(単位：人)',
      tip12: '',
      label13: '法人格位置',
      tip13: ''
    },
    industry: {
      title: '業種情報（＊必須項目）',
      label1: '業種（カテゴリー）',
      tip1: '選択',
      label2: '業種（詳細）',
      tip2: '選択',
      label3: '事業内容及び取扱商材',
      tip3: '例：飲食店',
      label4: '取扱商品最小単価／円',
      tip4: '',
      label5: '取扱商品最大単価／円',
      tip5: '',
    },
    address:{
      title:'本社住所（＊必須項目）',
      label1:'郵便番号',
      tip1:'例：1030026',
      stateLabel:'都道府号',
      cityLabel:'市区町村',
      streetLabel:'町名',
      extendedLabel:'番地',
      extended:'番地',
      state:'例：東京都',
      city:'例：中央区',
      street:'例：日本橋兜町',
      label2:'全角カタカナ',
      tip2_1:'例：トウキョウト',
      tip2_2:'例：チュウオウク',
      tip2_3:'例：ニホンバシカブトチョウ',
      label3:'建物名及び部屋番号',
      tip3:'例：1-1008',
      label4:'全角カタカナ',
      tip4:'例：ニホンバシカブトチョウ',
      label5:'電話番号',
      tip5:'例：03-6284-2302',
      label6:'ファックス',
      tip6:'例：090-1234-5678',
      label7:'緊急連絡先',
      tip7:'緊急連絡先',
       mobile:'携帯電話番号',
      mobiletip:'携帯電話番号',
    },

    representative:{
      title:'代表者様情報',
      firstName:'姓',
      lastName:'名',
      fullWidth:'全角カタカナ',
      enName:'英語表記',
      tip1:'例：高橋',
      tip2:'例：タカハシ',
      tip3:'例：TAKAHASHI',
      tip4:'例：一郎',
      tip5:'例：イチロウ',
      tip6:'例：ICHIRO',
      birthday: '生年月日',
      tip7:'例：2010-01-01',
      sex:'性别'
    },
    home:'代表者自宅住所',
    head:{
      title:'担当者様情報【ご担当者様へ当社よりご連絡を差し上げることがあります】',
      email:'メールアドレス',
      emaildetail: 'メールアドレスの形式が不正です',
      jobtitle:'職位',
      tip:'例：xxx@gmail.com',
      help:'※ メールアドレスは重要です。申込内容のご連絡や決済システムのID/PWをお送り致します',
    }
  }
}
